import React, { useEffect, useState } from "react";
import {  KYC_TYPE_QUERY } from "@aspen/model";
import { i18nUtil, getKycInformationNationalityValue, PROFILE_PATHS } from "@aspen/libs";
import { KycKeyValueTable } from "@adgm/cross-ui";
import type { TKycInformationColumn, TKycInformationSection } from "@adgm/libs";
import {
  mapIndividualDataToInformationArray,
  mapInstitutionDataToInformationArray,
} from "@adgm/libs";
import type { TKycInfoV2 } from "@adgm/cross-models";

interface IProps {
  kycInfo: TKycInfoV2;
  getKYCInfo: () => void;
}

export const PageKycInformationContentV1: React.FC<IProps> = props => {
  const { kycInfo } = props;
  const intl = i18nUtil.t();


  //TODO:kyc:  由于目前 问卷和展示页面存在冲突的地方不能放在一个多语言维护 ，之后再处理合并在一起
  const informationArray =
    kycInfo.type === KYC_TYPE_QUERY.institutions
      ? intl["kyc.institution.information"]
      : intl["kyc.individual.information"];

  const [kycInfoList, setKycInfoList] = useState<TKycInformationSection[]>(informationArray);

  // 表格组件 仅用于web端
  const KycInformationTable = ({ section }: { section: TKycInformationSection }) => {
    const { columns, tableData = [] } = section;
    if (!columns || !tableData.length) {
      return <div className="text-gray-500">No data available</div>;
    }

    return (
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr style={{ backgroundColor: "#2F3342" }}>
              {columns.map((column: TKycInformationColumn, index: number) => (
                <th
                  key={index}
                  className="px-4 py-3 text-center font-medium text-white text-sm"
                  style={{ border: "1px solid #42485C" }}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row: Record<string, unknown>, rowIndex: number) => (
              <tr key={rowIndex}>
                {columns.map((column: TKycInformationColumn, colIndex: number) => (
                  <td
                    key={colIndex}
                    className="px-4 py-3 text-white text-sm text-center whitespace-pre-line"
                    style={{ border: "1px solid #42485C" }}>
                    {getKycInformationNationalityValue(row[column.name], column.name)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  useEffect(() => {
    props.getKYCInfo();
  }, []);

  useEffect(() => {
    // 根据数据类型选择相应的处理方法
    let mappedData: TKycInformationSection[];
    if (kycInfo.type === KYC_TYPE_QUERY.institutions) {
      // 使用 institutionData 填充数据
      mappedData = mapInstitutionDataToInformationArray(kycInfo, informationArray);
    } else {
      // 使用 individualData 填充数据
      mappedData = mapIndividualDataToInformationArray(kycInfo, informationArray);
    }
    console.log("mappedData", mappedData);
    setKycInfoList(mappedData);
  }, [kycInfo]);

  return (<div className="">
    {kycInfoList.map(item => {
      return (
          <div key={item.name} className="mb-8">
            <div className="text-[24px] font-bold mb-6">{item.title}</div>
            {item.type === "table" ? (
                <KycInformationTable section={item} />
            ) : (
                // NO作为选项,不进行翻译~
                <div style={{ whiteSpace: "pre-line" }}>
                  <KycKeyValueTable
                      data={(item.fields || []).map(field => ({
                        label: field.label,
                        value: getKycInformationNationalityValue(field.value || "No", field.name),
                      }))}
                  />
                </div>
            )}
          </div>
      );
    })}
  </div>);
};

